import type { EdgeServer } from '../types'
import type { LampState } from './Lamp'

/**
 * 서버 한 대의 램프 상태 — 대시보드·뷰어 모니터 공용 규칙.
 * 오프라인 = 꺼짐, 의도적 모니터링 중지 = 황색, 연결 안 된 디바이스가 있으면 = 적색, 그 밖에는 = 녹색.
 */
export function serverLamp(s: EdgeServer): LampState {
  if (!s.isOnline) return 'off'
  if (s.reportedMonitoringState === 'Stopped') return 'warn'
  if ((s.deviceNotConnectedCount ?? 0) > 0) return 'fault'
  return 'run'
}

export const LAMP_TEXT: Record<LampState, string> = {
  run: '정상 가동',
  warn: '모니터링 중지',
  fault: '디바이스 이상',
  off: '오프라인',
}

/** "방금", "3분 전", "2시간 전", 하루가 넘으면 날짜 */
export function relativeTime(iso?: string | null) {
  if (!iso) return null
  const d = new Date(iso)
  const sec = Math.round((Date.now() - d.getTime()) / 1000)
  if (sec < 45) return '방금'
  if (sec < 3600) return `${Math.max(1, Math.round(sec / 60))}분 전`
  if (sec < 86400) return `${Math.round(sec / 3600)}시간 전`
  return d.toLocaleString('ko-KR', { month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false })
}
